/**
 * 自研区块链后端 (Spring Boot)：单一 API 基址，兼容原 /nft-web 路径。
 * 基址由 VITE_LST_API_BASE 或默认 http://localhost:8080 提供。
 */
export const STORAGE_KEY = "lst_api_platform";
export const PLATFORM_LST = "lst";

const DEFAULT_BASE = typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_LST_API_BASE
    ? import.meta.env.VITE_LST_API_BASE
    : "http://localhost:8080";

const apiBase = String(DEFAULT_BASE).replace(/\/$/, "");
const h5PageOrigin = typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : apiBase;

const PRESET = {
    id: PLATFORM_LST,
    label: "自研平台",
    shortLabel: "本地",
    apiBase,
    /** 与旧 YST「info 站」同源，公告 HTML 与 __injectJson 由该源提供；须与业务 API 同机（自研后端），勿再用页面 origin（开发时 :3000 会 404） */
    ystInfoOrigin: apiBase,
    ystHtmlReferer: h5PageOrigin + "/",
    devProxyPrefix: ""
};

export function getStoredPlatformId() {
    return PLATFORM_LST;
}
export function getLoginPasswordMd5Prefix() {
    return "YST";
}
export function setStoredPlatformId() {
}
export function getPlatformPreset() {
    return PRESET;
}
export function getApiBase() {
    return PRESET.apiBase.replace(/\/$/, "");
}
export function getYstInfoOrigin() {
    return PRESET.ystInfoOrigin.replace(/\/$/, "");
}
export function getYstHtmlReferer() {
    return PRESET.ystHtmlReferer;
}
export function getYstDevProxyPrefix() {
    return PRESET.devProxyPrefix || "";
}
export function getH5WebOrigin() {
    const ref = PRESET.ystHtmlReferer || "http://localhost:8080/";
    try {
        return new URL(ref).origin;
    }
    catch {
        return "http://localhost:8080";
    }
}
export const PLATFORM_OPTIONS = [PRESET];
